/* global window, moeditor, Intercom */
import React, { Component} from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'material-ui/MenuItem';
import SvgIcon from 'material-ui/SvgIcon';
import { PopoverFromTop } from 'crazyEditor/components/EditorUI/BaseUI/index';
import globalControlStyles from '../GlobalControlsStyles';
import styles from './HelpButtonStyles';
import {restartWalkThrough} from 'crazyEditor/redux/modules/editor/editor';
import {tooltipText} from 'shared/icons/index';

@connect(
  (state) => ({
    supportHome: state.general.supportLinks.supportHome
  }), {restartWalkThrough}
)
export default class HelpButton extends Component {
  state = {
    helpPopoverOpened: false
  };

  openHelpPopover = (event) => {
    this.setState({
      helpPopoverOpened: true,
      helpAnchorEl: event.currentTarget
    });
  };

  closeHelpPopover = () => {
    this.setState({
      helpPopoverOpened: false
    });
  };

  openKnowledgeBase = () => {
    const {supportHome} = this.props;
    window.open(supportHome);
  };

  render() {
    const {restartWalkThrough} = this.props;
    return (
      <span style={styles.container}>
        <FlatButton style={globalControlStyles.buttonStyle}
                    onClick={this.openHelpPopover}
                    children={<FontIcon style={globalControlStyles.iconButtonStyle} className="material-icons">help</FontIcon>}
        />
        <PopoverFromTop
          open={this.state.helpPopoverOpened}
          anchorEl={this.state.helpAnchorEl}
          onClose={this.closeHelpPopover}
        >
          <MenuItem style={globalControlStyles.menuItemStyle}
                    onClick={this.openKnowledgeBase}
                    primaryText="Knowledge base"
                    leftIcon={<FontIcon className="material-icons">school</FontIcon>}
          />
          <MenuItem style={globalControlStyles.menuItemStyle}
                    onClick={() => { /* eslint-disable */ window.Intercom('show'); /* eslint-enable */ }}
                    primaryText="Speak with us"
                    leftIcon={<FontIcon className="material-icons">live_help</FontIcon>}
          />
          <MenuItem style={globalControlStyles.menuItemStyle}
                    onClick={() => {
                      restartWalkThrough();
                      this.closeHelpPopover();
                    }}
                    primaryText="Show tutorial"
                    leftIcon={<SvgIcon><path d={tooltipText} /></SvgIcon>}
          />
        </PopoverFromTop>
      </span>
    );
  }
}
